const CODE_REGEX = /^SCRV-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}$/;

export function isValidCodeFormat(code) {
  return CODE_REGEX.test((code || '').toUpperCase().trim());
}
